import { CreditCardOutlined, NavigateBefore } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { PaymentSectionWrapper, SectionWrapper, StyledTitle } from "./styled";
import { colors } from "../../theme/colors";
import PayBiLogo from "../../assets/newLine/logo-pay-bi.webp";
import EbiPayLogo from "../../assets/ebipay logo.webp";
import { Field, Form } from "react-final-form";
import BITextFieldForm from "../../components/common/Forms/TextField/TextField";
import {
  cardLength,
  composeValidators,
  onlyNumbers,
  onlyText,
  phoneNumber,
  required,
  validateCvv,
  validateEmail,
  validateNIT,
} from "../../utils/validators";
import { StyledShopName } from "../Catalog/styled";
import { cc_expires_format, getInitials } from "../../utils/functions";

export default function Pay({
  prevStep,
  beneficiarie,
  product,
  executePayment,
  va,
}) {
  const [buttonHover, setButtonHover] = useState(false);
  const [cfSelected, setCfSelected] = useState(false);

  const enviarDatosOperacionales = (formValues) => {
    const ipUser = localStorage.getItem("ipUser") || "";
    const channelId = 23;
    const cardNumber = formValues.cardNumber;

    const payload = {
      transaction: {
        category: "oky",
        type: "checkout",
        details: {
          name: formValues.cardHolder,
          nit: formValues.nit || "CF",
          email: formValues.taxpayerEmail,
          last4Digits: cardNumber.slice(-4),
        },
      },
    };

    fetch(`${process.env.REACT_APP_SMARTID}/reportOperation`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {})
      .catch((error) => {
        console.warn("Error en fetch:", error.message);
      });
  };

  const handleSubmit = (formProps) => {
    const values = {
      payment: {
        cardNumber: formProps.cardNumber,
        cardHolder: formProps.cardHolder,
        expDate: formProps.expDate,
        cvv: formProps.cvv,
      },
      taxpayer: {
        nit: cfSelected ? "CF" : formProps.nit,
        phone: formProps.taxpayerPhone,
        email: formProps.taxpayerEmail,
      },
    };

    enviarDatosOperacionales(formProps);

    executePayment(values);
  };

  const handleSelectCF = (e) => {
    setCfSelected(e.target.checked);
  };

  return (
    <>
      <div style={{ maxWidth: "85%", margin: "auto" }}>
        <Divider sx={{ marginTop: "1rem", marginBottom: "1rem" }} />

        <Box display={{ xs: "none", sm: "block" }}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item>
              <IconButton onClick={prevStep}>
                <NavigateBefore
                  sx={{ color: colors.secondary, fontSize: "30px" }}
                />
              </IconButton>
            </Grid>
            <Grid item lg={5} sm={7} xl={4}>
              <StyledTitle>Datos de pago</StyledTitle>
            </Grid>
          </Grid>
        </Box>

        <Box display={{ xs: "block", sm: "none" }}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={1}>
              <IconButton onClick={prevStep}>
                <NavigateBefore
                  sx={{ color: colors.secondary, fontSize: "30px" }}
                />
              </IconButton>
            </Grid>
            <Grid item xs={11}>
              <StyledTitle>Datos de pago</StyledTitle>
            </Grid>
          </Grid>
        </Box>
      </div>

      <PaymentSectionWrapper>
        <SectionWrapper>
          <Grid container spacing={5} alignItems="center">
            <Grid item lg={4} xs={5}>
              {product.brandImage ? (
                <Avatar
                  sx={{
                    width: 80,
                    height: 80,
                    margin: "0.5rem",
                  }}
                  src={product.brandImage}
                />
              ) : (
                <StyledShopName
                  style={{
                    width: 80,
                    height: 80,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span>{getInitials(product.partner)}</span>
                </StyledShopName>
              )}
            </Grid>
            <Grid item lg={8} xs={7}>
              <Typography
                variant="h3"
                sx={{
                  "@media screen and (max-width: 450px)": {
                    fontSize: "1.5rem",
                  },
                }}
              >
                Q{" "}
                {product.productType === "RANGE_AMOUNT"
                  ? parseFloat(va) + parseFloat(product.fee)
                  : parseFloat(product.price) + parseFloat(product.fee)}
              </Typography>
              <Typography
                variant="h5"
                fontWeight="bold"
                sx={{
                  "@media screen and (max-width: 450px)": {
                    fontSize: "1rem",
                  },
                }}
              >
                {product.voucherName}
              </Typography>
            </Grid>
          </Grid>
        </SectionWrapper>

        <SectionWrapper>
          <Grid container spacing={5} alignItems="center">
            <Grid item lg={4} xs={5}>
              <Typography
                variant="h3"
                sx={{
                  "@media screen and (max-width: 450px)": {
                    fontSize: "1rem",
                  },
                }}
              >
                Datos del beneficiario
              </Typography>
            </Grid>
            <Grid item lg={8} xs={7}>
              <Typography
                variant="h5"
                fontWeight={"bold"}
                sx={{
                  "@media screen and (max-width: 450px)": {
                    fontSize: "1rem",
                  },
                }}
              >
                {beneficiarie.name} {beneficiarie.surname}
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  "@media screen and (max-width: 450px)": {
                    fontSize: "1rem",
                  },
                }}
              >
                {`+502 ${beneficiarie.phone}`}
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  "@media screen and (max-width: 450px)": {
                    fontSize: "1rem",
                  },
                }}
              >
                {beneficiarie.email}
              </Typography>
            </Grid>
          </Grid>
        </SectionWrapper>

        <div
          style={{
            marginTop: "4rem",
            marginBottom: "2rem",
            textAlign: "center",
          }}
        >
          <img src={PayBiLogo} alt="PayBi" />
        </div>

        <Form onSubmit={handleSubmit} initialValues={{}}>
          {(formProps) => (
            <form
              noValidate
              autoComplete="none"
              onSubmit={formProps.handleSubmit}
              style={{ maxWidth: "650px", margin: "auto" }}
            >
              <Divider
                sx={{
                  paddingLeft: "0",
                  paddingRight: "0",
                  "&::before, &::after": { borderColor: colors.gray.divider },
                }}
              >
                <Typography
                  variant="h4"
                  color="secondary"
                  sx={{
                    border: `1px ${colors.gray.divider} solid`,
                    padding: "0.5rem 3rem 0.5rem 3rem",
                    borderRadius: "12px",
                    "@media screen and (max-width: 376px)": {
                      fontSize: "1rem",
                    },
                  }}
                >
                  Datos de Tarjeta
                </Typography>
              </Divider>

              <Typography variant="h6" color={"primary"} fontWeight={"bold"}>
                Finaliza tu compra
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: "3rem" }}>
                Paga con tarjeta de crédito o débito y recuerda no compartir con
                nadie los números de tu tarjeta.
              </Typography>

              <Grid container columnSpacing={3} rowSpacing={4}>
                <Grid item sm={6} xs={12}>
                  <Field
                    name="cardNumber"
                    component={BITextFieldForm}
                    variant="outlined"
                    label="Número de Tarjeta"
                    required
                    placeholder="0000 0000 0000 0000"
                    validate={composeValidators(
                      required,
                      onlyNumbers(),
                      cardLength()
                    )}
                  />
                </Grid>

                <Grid item sm={6} xs={12}>
                  <Field
                    name="cardHolder"
                    component={BITextFieldForm}
                    variant="outlined"
                    label="Nombre"
                    required
                    placeholder="Ingresa un nombre"
                    validate={composeValidators(required, onlyText())}
                  />
                </Grid>

                <Grid item sm={6} xs={12}>
                  <Field
                    name="expDate"
                    component={BITextFieldForm}
                    variant="outlined"
                    label="Fecha de Vencimiento"
                    required
                    placeholder="00/00"
                    validate={composeValidators(required)}
                    format={(value) => cc_expires_format(String(value))}
                  />
                </Grid>

                <Grid item sm={6} xs={12}>
                  <Field
                    name="cvv"
                    component={BITextFieldForm}
                    variant="outlined"
                    label="CVV"
                    required
                    placeholder="000"
                    validate={composeValidators(required, validateCvv)}
                  />
                </Grid>
              </Grid>

              <Divider
                sx={{
                  paddingLeft: "0",
                  paddingRight: "0",
                  "&::before, &::after": { borderColor: colors.gray.divider },
                  marginTop: "3rem",
                  marginBottom: "3rem",
                }}
              >
                <Typography
                  variant="h4"
                  color="secondary"
                  sx={{
                    border: `1px ${colors.gray.divider} solid`,
                    padding: "0.5rem 3rem 0.5rem 3rem",
                    borderRadius: "12px",
                    "@media screen and (max-width: 376px)": {
                      fontSize: "1rem",
                    },
                  }}
                >
                  Datos de Facturación
                </Typography>
              </Divider>

              <Grid container columnSpacing={3} rowSpacing={4}>
                <Grid item sm={6} xs={12}>
                  <Field
                    name="nit"
                    component={BITextFieldForm}
                    variant="outlined"
                    label="NIT"
                    required={!cfSelected}
                    placeholder="0000000-0"
                    validate={
                      !cfSelected
                        ? composeValidators(required, validateNIT)
                        : null
                    }
                    disabled={cfSelected}
                  />
                </Grid>

                <Grid
                  item
                  sm={6}
                  xs={12}
                  alignContent="center"
                  sx={{ marginTop: { sm: "1rem" } }}
                >
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={
                            product.productType === "RANGE_AMOUNT"
                              ? parseFloat(va) >= 2500
                                ? true
                                : false
                              : parseFloat(product.price) >= 2500
                              ? true
                              : false
                          }
                          onChange={(e) => {
                            handleSelectCF(e);
                            if (e.target.checked)
                              formProps.form.resetFieldState("nit");
                          }}
                        />
                      }
                      label="Consumidor Final (CF)"
                    />
                  </FormGroup>
                </Grid>

                <Grid item sm={6} xs={12}>
                  <Field
                    name="taxpayerPhone"
                    component={BITextFieldForm}
                    variant="outlined"
                    label="Teléfono"
                    required
                    placeholder="+502 1234-5678"
                    validate={composeValidators(required, phoneNumber())}
                  />
                </Grid>

                <Grid item sm={6} xs={12}>
                  <Field
                    name="taxpayerEmail"
                    component={BITextFieldForm}
                    variant="outlined"
                    label="Correo electrónico"
                    required
                    placeholder="juanperez@mail.com"
                    validate={composeValidators(required, validateEmail())}
                  />
                </Grid>
              </Grid>

              <Button
                endIcon={
                  buttonHover ? <CreditCardOutlined color="secondary" /> : null
                }
                onMouseOver={() => setButtonHover(true)}
                onMouseOut={() => setButtonHover(false)}
                color={buttonHover ? "primary" : "secondary"}
                variant="contained"
                style={{
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "100%",
                  paddingRight: buttonHover ? "10%" : "initial",
                  transition: "padding 200ms",
                  paddingTop: "0.5rem",
                  paddingBottom: "0.5rem",
                  marginTop: "3rem",
                }}
                type="submit"
              >
                Pagar
              </Button>
            </form>
          )}
        </Form>
      </PaymentSectionWrapper>
    </>
  );
}
